import { FixtureType, FixtureViewType } from '@cds/betting-offer';
import { ScoreboardSlim } from '@cds/scoreboards/v1';
import { PlayerStats } from '@cds/statistics/player';
import {
    BaseEventModel,
    EventParticipant,
    EventScoreboard,
    EventStream,
    LeagueModel,
    SportModel,
} from '@frontend/sports/betting-offer/feature/model';

import { MarketStatInfo } from './my-bets-visualization-types';

export class MyBetsEventModel implements BaseEventModel {
    id: string;
    league: LeagueModel;
    live: boolean;
    name: string;
    groupId?: number;
    participants: EventParticipant[];
    scoreboard: EventScoreboard;
    sport: SportModel;
    startDate: Date;
    fixtureScoreboard: ScoreboardSlim;
    splitFixtureIds?: string[];
    stream?: EventStream;
    liveAlert?: boolean;
    offerContext?: string[];
    fixtureType: FixtureType;
    marketStatInfo?: MarketStatInfo[];
    playerStats?: PlayerStats[];
    viewType: FixtureViewType;

    constructor() {
        this.participants = [];
        this.scoreboard = new EventScoreboard();
        this.scoreboard.started = false;
    }
}
